import WebsiteModal from "modal/WebsiteModal";
import {svg_include} from "../index";
import Gallery from "../Gallery";

export default class ProductImageModal extends WebsiteModal {
    constructor(images) {
        super();
        this.images = images;
    }

    buildModal() {
        let $images = (eotwJSXFactory('div', {className: "gallery__items js-gallery-wrap"}));
        this.images.forEach((image, index) => {
            $images.append(
                eotwJSXFactory('div', {className: "gallery__item " + (index === 0 ? 'gallery__item--active' : '')}, [
                    eotwJSXFactory('img', {src: image})
                ])
            );
        });


        let $arrows = (
            eotwJSXFactory('div', {className: "gallery__arrows"}, [
                eotwJSXFactory('button', {type: "button", className: "arrow-btn js-navigate", title: "Previous", 'data-direction': "backwards", unsafeHtml: svg_include('dropdown-arrow')}),
                eotwJSXFactory('button', {type: "button", className: "arrow-btn arrow-btn--next js-navigate", title: "Next", 'data-direction': "forwards", unsafeHtml: svg_include('dropdown-arrow')})
            ])
        );

        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__close modal__close--white js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container gallery gallery--modal"}, [
                    eotwJSXFactory('div', {className: "modal__bg modal__bg--invisible js-close-modal"}),
                    $images,
                    this.images.length > 1 ? $arrows : ''
                ])
            ])
        );

        let gallery = new Gallery(this.$modal, {
            itemClass: "gallery__item",
            pipClass: "pips__btn",
            navigateClass: "js-navigate",
            pipsClass: "js-pips",
            itemsClass: "js-gallery-wrap",
            itemActiveModifier: "active",
            animationDuration: 0,
        });

        gallery.on('transitionEnd', ({from, to, direction}) => {
            gallery.$gallery.find('.js-current-slide').text(to + 1);
        });
    }

    buildElement() {
        this.buildModal();
    }
}